import type { StaticImageData } from 'next/image';

import type { SupportedLanguage } from '@/constants/language';

import step1Img from '@images/process-step-1.webp';
import step2Img from '@images/process-step-2.webp';
import step3Img from '@images/process-step-3.webp';
import step4Img from '@images/process-step-4.webp';
import step5Img from '@images/process-step-5.webp';

export interface Step {
  key: '1' | '2' | '3' | '4' | '5';
  img: StaticImageData;
  trackLabel: string;
  // 이동 목적지 — 모두 자사 내부 경로. 문자열=공통 경로, Record=로케일별 경로. 없으면(step4) 문의 팝업.
  href?: string | Record<SupportedLanguage, string>;
}

export const STEPS: Step[] = [
  {
    key: '1',
    img: step1Img,
    trackLabel: 'process_sample-guide',
    href: '/sample-preparation',
  },
  {
    key: '2',
    img: step2Img,
    trackLabel: 'process_genome-tech',
    href: {
      ko: '/blog/what-is-sequencing-in-genetic-test',
      en: '/blog/what-is-sequencing-why-it-matters-in-genetic-testing',
    },
  },
  {
    key: '3',
    img: step3Img,
    trackLabel: 'process_variant-tech',
    href: '/ai-variant-prediction',
  },
  { key: '4', img: step4Img, trackLabel: 'process_inquiry' },
  {
    key: '5',
    img: step5Img,
    trackLabel: 'process_sample-report',
    href: '/resources',
  },
];
